import { render, staticRenderFns } from "./ImportRawData.vue?vue&type=template&id=2b73b9a6"
import script from "./ImportRawData.vue?vue&type=script&lang=js"
export * from "./ImportRawData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports